export const TEMPLATE_LANGUAGES = [
  { key: 'de', label: 'DE', name: 'Deutsch' },
  { key: 'en', label: 'EN', name: 'English' },
  { key: 'it', label: 'IT', name: 'Italiano' },
  { key: 'fr', label: 'FR', name: 'Français' },
  { key: 'es', label: 'ES', name: 'Español' },
];

export const MESSAGE_TEMPLATES = [
  {
    key: 'saturdaytour',
    label: 'Saturday Tour (saturdaytour)',
    command: 'saturdaytour',
    contentSid: 'HX03e13bc8adb024e60070e9da92a950b5',
    whatsappTemplateName: 'saturdaytour',
    aliases: ['saturdaytour', 'samstag tour'],
    messages: {
      de: `Grüezi

Ihre E-Scooter-Lieferung/Abholung ist für Samstag geplante Tour vorgesehen. Unser Fahrer trifft während dem Lieferzeitfenster bei Ihnen ein.

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

Your e-scooter delivery/pickup is scheduled for the Saturday tour. Our driver will arrive during the delivery window.

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

La consegna/ritiro del suo monopattino è prevista per il tour del sabato.

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

L'enlèvement/livraison de votre trottinette est prévu pour la tournée du samedi.

Meilleures salutations
Votre équipe eScooterLab`,
      es: `Hola

La entrega/recogida de su patinete está programada para la ruta del sábado.

Saludos cordiales
Su equipo eScooterLab`,
    },
  },
  {
    key: 'tomorowtour',
    label: 'Tomorrow Tour (tomorowtour)',
    command: 'tomorowtour',
    contentSid: 'HX775a04ab6bb62b2ec77afcba92f53166',
    whatsappTemplateName: 'tomorowtour',
    aliases: ['tomorowtour', 'morgen tour'],
    messages: {
      de: `Grüezi

Ihre E-Scooter-Lieferung/Abholung findet morgen statt. Unser Fahrer trifft während dem angegebenen Zeitfenster bei Ihnen ein.

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

Your e-scooter delivery/pickup is taking place tomorrow. Our driver will arrive during the specified window.

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

La consegna/ritiro del suo monopattino avverrà domani.

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

L'enlèvement/livraison de votre trottinette aura lieu demain.

Meilleures salutations
Votre équipe eScooterLab`,
      es: `Hola

La entrega/recogida de su patinete se realizará mañana.

Saludos cordiales
Su equipo eScooterLab`,
    },
  },
  {
    key: 'driveinmin',
    label: 'Driver Arriving in Minutes (driveinmin)',
    command: 'driveinmin',
    contentSid: 'HXcbb6e7e1349a6f163cce103952ea07c9',
    whatsappTemplateName: 'driveinmin',
    aliases: ['driveinmin', 'fahrer kommt in wenigen minuten'],
    messages: {
      de: `Grüezi

Unser Fahrer ist unterwegs und trifft in wenigen Minuten bei Ihnen ein. Bitte halten Sie sich bereit.

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

Our driver is on the way and will arrive in a few minutes. Please be ready.

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

Il nostro autista è in arrivo e sarà da lei tra pochi minuti.

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

Notre chauffeur est en chemin und arrivera dans quelques minutes.

Meilleures salutations
Votre équipe eScooterLab`,
      es: `Hola

Nuestro conductor está en camino y llegará en pocos minutos.

Saludos cordiales
Su equipo eScooterLab`,
    },
  },
  {
    key: 'sprache',
    label: 'Language Selection (sprache)',
    command: 'sprache',
    contentSid: 'HX2a57294ba93db8bef93646e5102842e1',
    whatsappTemplateName: 'sprache',
    aliases: ['sprache', 'language picker'],
    messages: {
      de: `Grüezi

Bitte wählen Sie Ihre bevorzugte Sprache für die weitere Kommunikation aus:
1. Deutsch
2. English
3. Français
4. Italiano

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

Please select your preferred language for further communication:
1. Deutsch
2. English
3. Français
4. Italiano

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

Selezioni la lingua preferita per la comunicazione:
1. Deutsch
2. English
3. Français
4. Italiano

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

Veuillez choisir votre langue préférée pour la suite des échanges :
1. Deutsch
2. English
3. Français
4. Italiano

Meilleures salutations
Votre équipe eScooterLab`,
      es: `Hola

Por favor seleccione su idioma preferido para la comunicación:
1. Deutsch
2. English
3. Français
4. Italiano

Saludos cordiales
Su equipo eScooterLab`,
    },
  },

  {
    key: 'pickup-code',
    label: 'Pickup Code (Verification)',
    command: 'pickup code',
    whatsappTemplateName: 'pickup_code_resend',
    aliases: ['pickup code', 'code abholung', 'abholcode', 'security code'],
    messages: {
      de: `Grüezi

Hier ist Ihr Abhol-Bestätigungscode für Ihre E-Scooter-Abholung: {{pickup_code}}.
Bitte zeigen Sie diesen Code unserem Fahrer bei der Abholung vor.

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

Here is your security pickup code for your e-scooter pickup: {{pickup_code}}.
Please present this code to our driver upon collection.

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

Ecco il suo codice di verifica per il ritiro del monopattino: {{pickup_code}}.
La preghiamo di mostrare questo codice al nostro autista al momento del ritiro.

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

Voici votre code de sécurité pour l'enlèvement de votre trottinette : {{pickup_code}}.
Veuillez présenter ce code à notre chauffeur lors de la collecte.

Meilleures salutations
Votre équipe eScooterLab`,
      es: `Hola

Aquí tiene su código de seguridad para la recogida de su patinete: {{pickup_code}}.
Por favor presente este código a nuestro conductor durante la recogida.

Saludos cordiales
Su equipo eScooterLab`,
    },
  },
  {
    key: 'pickup-confirmation',
    label: 'Pickup confirmation',
    command: 'pickup confirmation',
    whatsappTemplateName: 'pickup_confirmation',
    aliases: ['pickup confirmed', 'abholung bestätigt', 'abholbestätigung'],
    messages: {
      de: `Grüezi

Ihr E-Scooter wurde erfolgreich abgeholt. Wir halten Sie über den Reparaturstatus auf dem Laufenden.

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

We have successfully picked up your e-scooter. We will keep you updated on the repair status.

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

Abbiamo ritirato con successo il suo monopattino. La terremo aggiornato sullo stato della riparazione.

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

Nous avons bien récupéré votre trottinette. Nous vous tiendrons informé de l'avancement de la réparation.

Meilleures salutations
Votre équipe eScooterLab`,
      es: `Hola

Hemos recogido con éxito su patinete eléctrico. Le mantendremos informado sobre el estado de la reparación.

Saludos cordiales
Su equipo eScooterLab`,
    },
  },
  {
    key: 'delivery-done',
    label: 'Delivery done',
    command: 'delivery done',
    whatsappTemplateName: 'delivery_done',
    aliases: ['delivery confirmed', 'zugestellt', 'lieferung erfolgt'],
    messages: {
      de: `Grüezi

Ihr reparierter E-Scooter wurde erfolgreich zugestellt. Vielen Dank, dass Sie sich für eScooterLab entschieden haben!

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

Your repaired e-scooter has been delivered. Thank you for choosing eScooterLab!

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

Il suo monopattino riparato è stato consegnato con successo. Grazie per aver scelto eScooterLab!

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

Votre trottinette réparée a été livrée avec succès. Merci d'avoir choisi eScooterLab !

Meilleures salutations
Votre équipe eScooterLab`,
      es: `Hola

Su patinete eléctrico reparado ha sido entregado con éxito. ¡Gracias por confiar en eScooterLab!

Saludos cordiales
Su equipo eScooterLab`,
    },
  },
  {
    key: 'eta-notification',
    label: 'ETA notification',
    command: 'eta notification',
    whatsappTemplateName: 'eta_notification',
    aliases: ['eta', 'ankunftszeit', 'unterwegs'],
    messages: {
      de: `Grüezi

Ihre E-Scooter-Lieferung/Abholung ist unterwegs. Unser Fahrer trifft in Kürze bei Ihnen ein.

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

Your e-scooter pickup/delivery is on its way. Our driver will arrive shortly.

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

Il ritiro/consegna del suo monopattino è in viaggio. Il nostro autista arriverà a breve.

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

L'enlèvement/livraison de votre trottinette est en route. Notre chauffeur arrivera incessamment.

Meilleures salutations
Votre équipe eScooterLab`,
      es: `Hola

La recogida/entrega de su patinete está en camino. Nuestro conductor llegará en breve.

Saludos cordiales
Su equipo eScooterLab`,
    },
  },
  {
    key: 'access-code-request',
    label: 'Access code request',
    command: 'access code request',
    whatsappTemplateName: 'access_code_request',
    aliases: ['access code', 'klingel', 'zugangscode'],
    messages: {
      de: `Grüezi

Könnten Sie uns bitte den Zugangscode oder Klingelinformationen für Ihren Standort senden? Vielen Dank!

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

Could you please send us the access code or buzzer information for your location? Thank you!

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

Potrebbe inviarci il codice di accesso o le informazioni sul citofono della sua posizione? Grazie!

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

Pourriez-vous nous transmettre le code d'accès ou l'interphone pour votre adresse ? Merci !

Meilleures salutations
Votre équipe eScooterLab`,
      es: `Hola

¿Podría enviarnos el código de acceso o la información del interfono para su ubicación? ¡Muchas gracias!

Saludos cordiales
Su equipo eScooterLab`,
    },
  },

  {
    key: 'missed-call',
    label: 'Missed call',
    command: 'missed call',
    whatsappTemplateName: 'missed_call_follow_up',
    aliases: ['missed', 'anruf verpasst'],
    messages: {
      de: `Grüezi

Vielen Dank für Ihren Anruf. Leider haben wir heute Ihren Anruf verpasst. Wie dürfen wir Ihnen behilflich sein? Bitte teilen Sie uns mit, um welche Marke und welches Modell es sich bei Ihrer Anfrage handelt?

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

Thank you for your call. Unfortunately, we missed your call today. How may we help you? Please let us know which brand and model your request is about.

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

Grazie per la sua chiamata. Purtroppo oggi non siamo riusciti a rispondere. Come possiamo aiutarla? La preghiamo di indicarci marca e modello relativi alla sua richiesta.

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

Merci pour votre appel. Malheureusement, nous avons manqué votre appel aujourd'hui. Comment pouvons-nous vous aider ? Merci de nous indiquer la marque et le modèle concernés par votre demande.

Meilleures salutations
Votre équipe eScooterLab`,
    },
  },
  {
    key: 'workshop-calendar',
    label: 'Workshop calendar',
    command: 'workshop calendar',
    aliases: ['calendar', 'werkstatt kalender', 'booking link'],
    messages: {
      de: `Grüezi

Vielen Dank für Ihre Anfrage.
Hier finden Sie den Link zum Werkstatt-Kalender, über den Sie Werkstattbesuche und Abholungen direkt anfragen können: https://escooterlab.ch/werkstatt-kalender

Bei Fragen stehe ich Ihnen selbstverständlich gerne zur Verfügung.

Ihr escooterlab.ch Team`,
      en: `Hello

Thank you for your request.
You can use the workshop booking calendar to request workshop visits and pick-ups directly: https://escooterlab.ch/werkstatt-kalender

If you have any questions, I will be happy to help.

Your escooterlab.ch Team`,
      it: `Buongiorno

Grazie per la sua richiesta.
Qui trova il link al calendario dell'officina, dove può richiedere direttamente visite in officina e ritiri: https://escooterlab.ch/werkstatt-kalender

Per qualsiasi domanda resto volentieri a disposizione.

Il team escooterlab.ch`,
      fr: `Bonjour

Merci pour votre demande.
Voici le lien vers le calendrier de l'atelier, où vous pouvez demander directement un passage en atelier ou un enlèvement: https://escooterlab.ch/werkstatt-kalender

Je reste bien entendu à votre disposition pour toute question.

Votre équipe escooterlab.ch`,
    },
  },
  {
    key: 'ready-to-drive',
    label: 'Ready to drive',
    command: 'ready to drive',
    aliases: ['ready', 'pickup ready', 'abholbereit'],
    messages: {
      de: `Grüezi

Ihr E-Scooter steht zur Abholung bereit. Bitte lassen Sie uns wissen, wann es Ihnen am besten passt, ihn abzuholen.

Wir wünschen Ihnen eine angenehme Fahrt und stehen Ihnen bei Fragen gerne zur Verfügung.

Freundliche Grüsse
Ihr eScooterLab Team`,
      en: `Hello

Your e-scooter is ready for collection. Please let us know when it suits you best to pick it up.

We wish you a pleasant ride and remain available if you have any questions.

Kind regards
Your eScooterLab Team`,
      it: `Buongiorno

Il suo e-scooter è pronto per il ritiro. La preghiamo di farci sapere quando le è più comodo ritirarlo.

Le auguriamo una piacevole guida e restiamo a disposizione per qualsiasi domanda.

Cordiali saluti
Il team eScooterLab`,
      fr: `Bonjour

Votre e-scooter est prêt à être récupéré. Merci de nous indiquer le moment qui vous convient le mieux pour venir le chercher.

Nous vous souhaitons une bonne route et restons à votre disposition pour toute question.

Meilleures salutations
Votre équipe eScooterLab`,
    },
  },
  {
    key: 'missing-vehicle-infos',
    label: 'Missing vehicle infos',
    command: 'missing vehicle infos',
    aliases: ['missing info', 'missing vehicle info', 'vehicle infos'],
    messages: {
      de: `Grüezi

Vielen Dank für Ihre Reservation.

Leider fehlen uns noch einige Angaben, um den Schaden korrekt einschätzen und die Reparatur effizient vorbereiten zu können. Bitte senden Sie uns folgende Informationen und Unterlagen:
- Marke und Modell Ihres E-Scooters
- Aktueller Defekt
- Fotos des Scooters (Fernaufnahme sowie Detailaufnahme des Defekts)
- Wenn vorhanden: ein Foto des Fahrzeugschilds
- Kaufbeleg (zur Einschätzung von Garantie und Alter des Fahrzeugs)

Sobald wir diese Informationen erhalten haben, senden wir Ihnen einen Richtpreis basierend auf unserer Erfahrung. Zusätzlich teilen wir Ihnen mit, welche Partnerwerkstatt in unserem Netzwerk die Reparatur am schnellsten durchführen kann.

Vielen Dank für Ihre Mithilfe. Bei Fragen stehen wir Ihnen selbstverständlich jederzeit zur Verfügung.

Freundliche Grüsse
Simon Buholzer`,
      en: `Hello

Thank you for your reservation.

We are still missing some information to assess the damage correctly and prepare the repair efficiently. Please send us the following information and documents:
- Brand and model of your e-scooter
- Current defect
- Photos of the scooter (one overview photo and one close-up of the defect)
- If available: a photo of the vehicle label
- Purchase receipt (to assess warranty and vehicle age)

Once we receive this information, we will send you an estimated price based on our experience. We will also let you know which partner workshop in our network can complete the repair the fastest.

Thank you for your help. If you have any questions, we are always happy to assist.

Kind regards
Simon Buholzer`,
      it: `Buongiorno

Grazie per la sua prenotazione.

Ci mancano ancora alcune informazioni per valutare correttamente il danno e preparare la riparazione in modo efficiente. La preghiamo di inviarci:
- Marca e modello del suo e-scooter
- Difetto attuale
- Foto dello scooter (una foto generale e un dettaglio del difetto)
- Se disponibile: una foto della targhetta del veicolo
- Prova d'acquisto (per valutare garanzia ed età del veicolo)

Non appena avremo ricevuto queste informazioni, le invieremo un prezzo indicativo basato sulla nostra esperienza. Le comunicheremo inoltre quale officina partner della nostra rete può eseguire la riparazione più rapidamente.

Grazie per la collaborazione. Restiamo sempre a disposizione per qualsiasi domanda.

Cordiali saluti
Simon Buholzer`,
      fr: `Bonjour

Merci pour votre réservation.

Il nous manque encore quelques informations afin d'évaluer correctement les dommages et de préparer la réparation efficacement. Merci de nous envoyer les informations et documents suivants:
- Marque et modèle de votre e-scooter
- Défaut actuel
- Photos du scooter (une vue d'ensemble et un gros plan du défaut)
- Si disponible: une photo de la plaque signalétique
- Preuve d'achat (pour évaluer la garantie et l'âge du véhicule)

Dès réception de ces informations, nous vous enverrons un prix indicatif basé sur notre expérience. Nous vous indiquerons également quel atelier partenaire de notre réseau peut effectuer la réparation le plus rapidement.

Merci pour votre aide. Nous restons bien entendu à votre disposition pour toute question.

Meilleures salutations
Simon Buholzer`,
    },
  },
  {
    key: 'google-review',
    label: 'Google review',
    command: 'google review',
    aliases: ['review', 'bewertung'],
    messages: {
      de: `Sehr geehrter Kunde

Vielen Dank, dass Du eScooterLab genutzt hast. Es hat uns gefreut, Dir behilflich zu sein.

Wie vereinbart, bekommst Du hier den Link, um unsere Dienstleistung zu bewerten:
Hier geht's zur Bewertung: https://g.page/r/CXtcp9Xw8L2ZEBM/review

Wir schätzen Dein Feedback sehr und bedanken uns im Voraus für deine Unterstützung!

Freundliche Grüsse und angenehme Fahrt

Ihr eScooterLab Team
escooterlab.ch`,
      en: `Dear customer

Thank you for choosing eScooterLab. We were happy to help you.

As discussed, here is the link to review our service:
Review us here: https://g.page/r/CXtcp9Xw8L2ZEBM/review

We truly appreciate your feedback and thank you in advance for your support.

Kind regards and enjoy your ride

Your eScooterLab Team
escooterlab.ch`,
      it: `Gentile cliente

Grazie per aver scelto eScooterLab. Siamo stati felici di poterla aiutare.

Come concordato, ecco il link per valutare il nostro servizio:
Lasci una recensione qui: https://g.page/r/CXtcp9Xw8L2ZEBM/review

Apprezziamo molto il suo feedback e la ringraziamo in anticipo per il suo supporto.

Cordiali saluti e buona guida

Il team eScooterLab
escooterlab.ch`,
      fr: `Cher client

Merci d'avoir choisi eScooterLab. Nous avons été ravis de pouvoir vous aider.

Comme convenu, voici le lien pour évaluer notre service:
Donnez votre avis ici: https://g.page/r/CXtcp9Xw8L2ZEBM/review

Votre retour nous est très précieux et nous vous remercions d'avance pour votre soutien.

Meilleures salutations et bonne route

Votre équipe eScooterLab
escooterlab.ch`,
    },
  },
  {
    key: 'brand-model',
    label: 'Brand model',
    command: 'brand model',
    aliases: ['brand', 'model', 'marke modell'],
    messages: {
      de: `Grüezi

Vielen Dank für Ihre Anfrage zur Reparatur Ihres Elektroscooters.

Leider haben Sie weder die Marke noch das Modell angegeben.
Falls Sie diese Angaben nicht kennen, senden Sie uns bitte ein Foto des Scooters, damit wir prüfen können, ob die benötigten Ersatzteile verfügbar sind und Ihnen eine Kostenschätzung abgeben können. Bitte beschreiben Sie den Defekt und teilen Sie mit, an welchem Standort sich das Gerät befindet (inklusive Postleitzahl und Stadt).

Für Rückfragen stehen wir Ihnen gerne zur Verfügung.

Freundliche Grüsse

Simon Buholzer`,
      en: `Hello

Thank you for your repair request for your electric scooter.

Unfortunately, you did not provide the brand or model.
If you do not know these details, please send us a photo of the scooter so we can check whether the required spare parts are available and provide a cost estimate. Please also describe the defect and tell us where the device is located (including postal code and city).

We are happy to help if you have any questions.

Kind regards

Simon Buholzer`,
      it: `Buongiorno

Grazie per la sua richiesta di riparazione per il suo monopattino elettrico.

Purtroppo non ha indicato né la marca né il modello.
Se non conosce questi dati, ci invii una foto del monopattino, così possiamo verificare se i ricambi necessari sono disponibili e preparare una stima dei costi. La preghiamo inoltre di descrivere il difetto e comunicarci dove si trova il dispositivo (inclusi codice postale e città).

Restiamo volentieri a disposizione per qualsiasi domanda.

Cordiali saluti

Simon Buholzer`,
      fr: `Bonjour

Merci pour votre demande de réparation de votre trottinette électrique.

Malheureusement, vous n'avez pas indiqué la marque ni le modèle.
Si vous ne connaissez pas ces informations, merci de nous envoyer une photo du scooter afin que nous puissions vérifier si les pièces nécessaires sont disponibles et vous transmettre une estimation des coûts. Merci également de décrire le défaut et de nous indiquer où se trouve l'appareil (code postal et ville inclus).

Nous restons à votre disposition pour toute question.

Meilleures salutations

Simon Buholzer`,
    },
  },
  {
    key: 'swap',
    label: 'Swap',
    command: 'swap',
    aliases: ['eintausch', 'trade in'],
    messages: {
      de: `Eintauschaktion 2026 - Jetzt profitieren!
Gerne bieten wir Ihnen ein exklusives Eintausch-Angebot für Ihren alten E-Scooter an:

https://escooterlab.ch/escooter-swap

Erhalten Sie beim Kauf eines brandneuen Segway Ninebot E2 Pro (25 km/h, 35 km Reichweite, 350 W) folgende Vorteile:

200 CHF Gutschrift mit dem Gutscheincode: Swap2025
100 CHF Servicegutschein für Wartung oder Reparatur
2 Jahre Herstellergarantie

Jetzt im Online-Shop bestellen:

Zum Produkt im Shop:
https://escooterlab.ch/e-scooter-kaufen-onlineshop/Segway-Ninebot-E2-Pro-E-25-Kmh-35-Km-350-W

So funktioniert's:
1. Legen Sie den Scooter in den Warenkorb
2. Geben Sie beim Checkout den Gutscheincode Swap2025 ein
3. Der Rabatt wird automatisch abgezogen
4. Sie erhalten den Servicegutschein separat per E-Mail

Gerne übernehmen wir auch die umweltgerechte Entsorgung Ihres alten E-Scooters.
Bei Fragen stehen wir Ihnen jederzeit zur Verfügung!

Freundliche Grüsse und eine angenehme Fahrt

Simon Buholzer
escooterlab.ch
Telefon: +41 71 539 18 47
E-Mail: info@escooterlab.ch
Webseite: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
      en: `Trade-in campaign 2026 - benefit now!
We are happy to offer you an exclusive trade-in offer for your old e-scooter:

https://escooterlab.ch/escooter-swap

When purchasing a brand-new Segway Ninebot E2 Pro (25 km/h, 35 km range, 350 W), you receive:

CHF 200 credit with voucher code: Swap2025
CHF 100 service voucher for maintenance or repair
2-year manufacturer warranty

Order now in the online shop:

Product link:
https://escooterlab.ch/e-scooter-kaufen-onlineshop/Segway-Ninebot-E2-Pro-E-25-Kmh-35-Km-350-W

How it works:
1. Add the scooter to your cart
2. Enter voucher code Swap2025 at checkout
3. The discount is deducted automatically
4. You receive the service voucher separately by email

We are also happy to dispose of your old e-scooter in an environmentally friendly way.
If you have any questions, we are always available.

Kind regards and enjoy your ride

Simon Buholzer
escooterlab.ch
Phone: +41 71 539 18 47
Email: info@escooterlab.ch
Website: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
      it: `Campagna permuta 2026 - approfitti ora!
Siamo lieti di offrirle un'offerta esclusiva di permuta per il suo vecchio e-scooter:

https://escooterlab.ch/escooter-swap

Acquistando un nuovo Segway Ninebot E2 Pro (25 km/h, autonomia 35 km, 350 W), riceve:

CHF 200 di credito con il codice voucher: Swap2025
CHF 100 di buono servizio per manutenzione o riparazione
2 anni di garanzia del produttore

Ordini ora nello shop online:

Link prodotto:
https://escooterlab.ch/e-scooter-kaufen-onlineshop/Segway-Ninebot-E2-Pro-E-25-Kmh-35-Km-350-W

Come funziona:
1. Inserisca lo scooter nel carrello
2. Inserisca il codice voucher Swap2025 al checkout
3. Lo sconto viene detratto automaticamente
4. Riceverà il buono servizio separatamente via e-mail

Saremo lieti di occuparci anche dello smaltimento ecologico del suo vecchio e-scooter.
Per qualsiasi domanda siamo sempre a disposizione.

Cordiali saluti e buona guida

Simon Buholzer
escooterlab.ch
Telefono: +41 71 539 18 47
E-mail: info@escooterlab.ch
Sito web: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
      fr: `Action reprise 2026 - profitez-en maintenant !
Nous vous proposons volontiers une offre de reprise exclusive pour votre ancien e-scooter:

https://escooterlab.ch/escooter-swap

À l'achat d'un Segway Ninebot E2 Pro neuf (25 km/h, autonomie 35 km, 350 W), vous recevez:

CHF 200 de crédit avec le code voucher: Swap2025
CHF 100 de bon de service pour entretien ou réparation
2 ans de garantie fabricant

Commandez maintenant dans la boutique en ligne:

Lien produit:
https://escooterlab.ch/e-scooter-kaufen-onlineshop/Segway-Ninebot-E2-Pro-E-25-Kmh-35-Km-350-W

Comment ça marche:
1. Ajoutez le scooter au panier
2. Saisissez le code voucher Swap2025 au checkout
3. La réduction est déduite automatiquement
4. Vous recevez le bon de service séparément par e-mail

Nous nous chargeons également volontiers de l'élimination écologique de votre ancien e-scooter.
Nous restons à votre disposition pour toute question.

Meilleures salutations et bonne route

Simon Buholzer
escooterlab.ch
Téléphone: +41 71 539 18 47
E-mail: info@escooterlab.ch
Site web: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
    },
  },
  {
    key: 'dropoff-zurich',
    label: 'Dropoff Zürich',
    command: 'dropoff zurich',
    aliases: ['dropoff zürich', 'zurich dropoff', 'zuerich dropoff'],
    messages: {
      de: `Grüezi

Vielen Dank für Ihre Reservierung. Gerne bestätigen wir Ihnen hiermit die Terminvereinbarung.
Sie können den E-Scooter bei unserer Depostelle an der Neuhausstrasse 2, 8044 Zürich abgeben.

Sollten Sie vorab noch Fragen haben, stehen wir Ihnen selbstverständlich gerne zur Verfügung.

Freundliche Grüsse und eine angenehme Fahrt.

Simon Buholzer
escooterlab.ch
Telefon: +41 71 539 18 47
E-Mail: info@escooterlab.ch
Webseite: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
      en: `Hello

Thank you for your reservation. We are happy to confirm your appointment.
You can drop off the e-scooter at our drop-off point at Neuhausstrasse 2, 8044 Zurich.

If you have any questions beforehand, we will be happy to help.

Kind regards and enjoy your ride.

Simon Buholzer
escooterlab.ch
Phone: +41 71 539 18 47
Email: info@escooterlab.ch
Website: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
      it: `Buongiorno

Grazie per la sua prenotazione. Confermiamo volentieri l'appuntamento.
Può consegnare l'e-scooter presso il nostro punto di deposito in Neuhausstrasse 2, 8044 Zurigo.

Se ha domande prima dell'appuntamento, siamo volentieri a disposizione.

Cordiali saluti e buona guida.

Simon Buholzer
escooterlab.ch
Telefono: +41 71 539 18 47
E-mail: info@escooterlab.ch
Sito web: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
      fr: `Bonjour

Merci pour votre réservation. Nous vous confirmons volontiers le rendez-vous.
Vous pouvez déposer l'e-scooter à notre point de dépôt à Neuhausstrasse 2, 8044 Zurich.

Si vous avez des questions avant le rendez-vous, nous restons bien entendu à votre disposition.

Meilleures salutations et bonne route.

Simon Buholzer
escooterlab.ch
Téléphone: +41 71 539 18 47
E-mail: info@escooterlab.ch
Site web: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
    },
  },
  {
    key: 'pickup-zurich',
    label: 'Pickup Zürich',
    command: 'pickup zurich',
    aliases: ['pickup zürich', 'abholung zürich', 'abholung zurich'],
    messages: {
      de: `Grüezi

Ihr eScooter wurde erfolgreich repariert und ist nun abholbereit.

Abholung:
Ihr Gerät befindet sich bei Beat an der Neuhausstrasse 2, 8044 Zürich.
Bitte melden Sie Ihre Abholung im Voraus an, damit der Mechaniker während dieser Zeit nicht auf einer Probefahrt ist.

Kosten:
Der Reparaturbetrag beträgt CHF 100.-
Bitte begleichen Sie den Betrag entweder:
- via TWINT an: +41 79 888 92 88
- oder per Überweisung auf folgendes Konto:
IBAN: CH30 0077 9000 2217 7610 2

Wichtig:
Bringen Sie den Zahlungsnachweis unaufgefordert zur Abholung mit. Ohne diesen kann das Fahrzeug nicht ausgehändigt werden.

Lieferung:
Falls Sie eine verbindliche Auslieferung nach Hause wünschen, fällt ein Aufpreis von CHF 38.- an.

Vielen Dank für Ihr Verständnis.

Freundliche Grüsse
Simon Buholzer
escooterlab.ch`,
      en: `Hello

Your e-scooter has been repaired successfully and is now ready for collection.

Collection:
Your device is with Beat at Neuhausstrasse 2, 8044 Zurich.
Please announce your collection in advance so the mechanic is not on a test ride at that time.

Costs:
The repair amount is CHF 100.-
Please pay either:
- via TWINT to: +41 79 888 92 88
- or by bank transfer to:
IBAN: CH30 0077 9000 2217 7610 2

Important:
Please bring proof of payment with you when collecting the vehicle. Without it, the vehicle cannot be handed over.

Delivery:
If you would like a confirmed home delivery, there is a surcharge of CHF 38.-

Thank you for your understanding.

Kind regards
Simon Buholzer
escooterlab.ch`,
      it: `Buongiorno

Il suo e-scooter è stato riparato con successo ed è ora pronto per il ritiro.

Ritiro:
Il suo dispositivo si trova da Beat in Neuhausstrasse 2, 8044 Zurigo.
La preghiamo di annunciare il ritiro in anticipo, così il meccanico non sarà fuori per un giro di prova in quel momento.

Costi:
L'importo della riparazione è di CHF 100.-
La preghiamo di pagare:
- via TWINT a: +41 79 888 92 88
- oppure tramite bonifico al seguente conto:
IBAN: CH30 0077 9000 2217 7610 2

Importante:
Porti con sé la prova di pagamento al momento del ritiro. Senza di essa il veicolo non potrà essere consegnato.

Consegna:
Se desidera una consegna a domicilio confermata, è previsto un supplemento di CHF 38.-

Grazie per la comprensione.

Cordiali saluti
Simon Buholzer
escooterlab.ch`,
      fr: `Bonjour

Votre e-scooter a été réparé avec succès et est maintenant prêt à être récupéré.

Récupération:
Votre appareil se trouve chez Beat à Neuhausstrasse 2, 8044 Zurich.
Merci d'annoncer votre passage à l'avance afin que le mécanicien ne soit pas en essai routier à ce moment-là.

Coûts:
Le montant de la réparation est de CHF 100.-
Merci de régler le montant:
- via TWINT au: +41 79 888 92 88
- ou par virement bancaire sur le compte suivant:
IBAN: CH30 0077 9000 2217 7610 2

Important:
Merci d'apporter spontanément la preuve de paiement lors de la récupération. Sans celle-ci, le véhicule ne pourra pas être remis.

Livraison:
Si vous souhaitez une livraison à domicile confirmée, un supplément de CHF 38.- s'applique.

Merci pour votre compréhension.

Meilleures salutations
Simon Buholzer
escooterlab.ch`,
    },
  },
  {
    key: 'repair-options',
    label: 'Repair options',
    command: 'repair options',
    aliases: ['reifen options', 'tire options', 'tyre options'],
    messages: {
      de: `Grüezi

Vielen Dank für Ihren Auftrag und das Vertrauen in eScooterLab.

Bitte teilen Sie uns mit, welche Reifenvariante Sie für Ihren E-Scooter wünschen:

Vollgummireifen - CHF 121.00
Wartungsfrei und pannensicher, keine Luftfüllung erforderlich.

Reifen mit Innenschlauch - CHF 86.00
Günstiger, jedoch ohne Garantie auf Luftverlust oder Plattfuss.

Sobald wir Ihre Wahl erhalten, können wir den Auftrag entsprechend vorbereiten und Ihnen den Termin für die Reparatur bestätigen.

Für Rückfragen stehen wir Ihnen selbstverständlich gerne zur Verfügung.

Umweltfreundliche Grüsse

Simon Buholzer
escooterlab.ch

Telefon: +41 71 539 18 47
E-Mail: info@escooterlab.ch

Webseite: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
      en: `Hello

Thank you for your order and your trust in eScooterLab.

Please let us know which tire option you would like for your e-scooter:

Solid rubber tire - CHF 121.00
Maintenance-free and puncture-proof, no air filling required.

Tire with inner tube - CHF 86.00
Less expensive, but without warranty for air loss or punctures.

As soon as we receive your choice, we can prepare the order accordingly and confirm the repair appointment.

If you have any questions, we will be happy to help.

Eco-friendly regards

Simon Buholzer
escooterlab.ch

Phone: +41 71 539 18 47
Email: info@escooterlab.ch

Website: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
      it: `Buongiorno

Grazie per il suo incarico e per la fiducia in eScooterLab.

La preghiamo di indicarci quale variante di pneumatico desidera per il suo e-scooter:

Pneumatico in gomma piena - CHF 121.00
Senza manutenzione e resistente alle forature, non richiede gonfiaggio.

Pneumatico con camera d'aria - CHF 86.00
Più conveniente, ma senza garanzia contro perdita d'aria o forature.

Non appena riceveremo la sua scelta, potremo preparare l'ordine e confermare l'appuntamento per la riparazione.

Restiamo volentieri a disposizione per qualsiasi domanda.

Saluti ecologici

Simon Buholzer
escooterlab.ch

Telefono: +41 71 539 18 47
E-mail: info@escooterlab.ch

Sito web: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
      fr: `Bonjour

Merci pour votre mandat et pour votre confiance en eScooterLab.

Merci de nous indiquer quelle variante de pneu vous souhaitez pour votre e-scooter:

Pneu plein - CHF 121.00
Sans entretien et résistant aux crevaisons, aucun gonflage nécessaire.

Pneu avec chambre à air - CHF 86.00
Moins cher, mais sans garantie contre la perte d'air ou les crevaisons.

Dès réception de votre choix, nous pourrons préparer la commande et confirmer le rendez-vous de réparation.

Nous restons bien entendu à votre disposition pour toute question.

Salutations écologiques

Simon Buholzer
escooterlab.ch

Téléphone: +41 71 539 18 47
E-mail: info@escooterlab.ch

Site web: www.escooterlab.ch

escooterlab.ch
Frankenstrasse 18
6003 Luzern`,
    },
  },
  {
    key: 'waiting-time',
    label: 'Waiting time',
    command: 'waiting time',
    aliases: ['wartezeit', 'delay'],
    messages: {
      de: `Vielen Dank für Ihre Geduld und Ihr Verständnis.

Leider müssen wir Ihnen mitteilen, dass es aktuell aufgrund eines erhöhten Arbeitsaufkommens zu längeren Wartezeiten kommt. Wir arbeiten mit Hochdruck daran, alle Reparaturen und Anfragen so schnell wie möglich zu bearbeiten und die gewohnte Qualität unserer Dienstleistungen sicherzustellen.

Ihr escooterlab.ch Team`,
      en: `Thank you for your patience and understanding.

Unfortunately, due to increased workload, longer waiting times may currently occur. We are working hard to process all repairs and requests as quickly as possible while maintaining our usual service quality.

Your escooterlab.ch Team`,
      it: `Grazie per la pazienza e la comprensione.

Purtroppo, a causa dell'elevato carico di lavoro, al momento possono verificarsi tempi di attesa più lunghi. Stiamo lavorando intensamente per gestire tutte le riparazioni e richieste il più rapidamente possibile, mantenendo la qualità abituale dei nostri servizi.

Il team escooterlab.ch`,
      fr: `Merci pour votre patience et votre compréhension.

Malheureusement, en raison d'une charge de travail accrue, les délais d'attente peuvent actuellement être plus longs. Nous travaillons intensivement afin de traiter toutes les réparations et demandes aussi rapidement que possible tout en garantissant notre qualité de service habituelle.

Votre équipe escooterlab.ch`,
    },
  },
  {
    key: 'adressluzern',
    label: 'Adress Luzern',
    command: 'adressluzern',
    aliases: ['address luzern', 'adresse luzern', 'adress luzern', 'luzern address'],
    messages: {
      de: `Grüezi

Wie vereinbart erhalten Sie hier den Standort, an dem Sie den E-Scooter bequem abladen können - ganz ohne Parkplatzsuche. Vor Ort haben wir zudem die Möglichkeit, Probefahrten zu machen:

Winkelriedstrasse 29
6003 Luzern
Schweiz

Freundliche Grüsse
Simon Buholzer`,
      en: `Hello

As agreed, here is the location where you can conveniently drop off the e-scooter without having to search for parking. We also have the possibility to do test rides on site:

Winkelriedstrasse 29
6003 Luzern
Switzerland

Kind regards
Simon Buholzer`,
      it: `Buongiorno

Come concordato, ecco il luogo dove può scaricare comodamente l'e-scooter senza cercare parcheggio. Sul posto abbiamo anche la possibilità di effettuare giri di prova:

Winkelriedstrasse 29
6003 Lucerna
Svizzera

Cordiali saluti
Simon Buholzer`,
      fr: `Bonjour

Comme convenu, voici l'emplacement où vous pouvez déposer facilement l'e-scooter sans devoir chercher une place de parking. Sur place, nous avons également la possibilité d'effectuer des essais:

Winkelriedstrasse 29
6003 Lucerne
Suisse

Meilleures salutations
Simon Buholzer`,
    },
  },
  {
    key: 'tomorrowtour',
    label: 'Tomorrow tour',
    command: 'tomorrow tour',
    aliases: ['tomorrowtour', 'abholtour morgen', 'mobile werkstatt morgen', 'free pickup tomorrow'],
    messages: {
      de: `Grüezi

Ihre Reparaturanfrage wurde für morgen in unsere kostenlose Abholtour mit mobilen Werkstatt eingeplant.
Unser Fahrer wird Sie ungefähr eine Stunde vor der Anfahrt kontaktieren.

Bitte beachten Sie: Sollte die Anfahrt erfolgen, jedoch keine Reparatur durchgeführt oder kein Reparaturauftrag erteilt werden, verrechnen wir eine Anfahrtspauschale von CHF 30.–. Entscheiden Sie sich bei einer späteren Tour für die Reparatur, wird Ihnen dieser Betrag vollständig gutgeschrieben.

Umweltfreundliche Grüsse und sichere Fahrt
Simon Buholzer
escooterlab.ch`,
      en: `Hello

Your repair request has been scheduled for tomorrow in our free pick-up tour with mobile workshop.
Our driver will contact you approximately one hour before arriving.

Please note: If our driver arrives but no repair is carried out or no repair order is placed, we charge a flat call-out fee of CHF 30.–. Should you decide to proceed with the repair on a later tour, this amount will be fully credited to you.

Eco-friendly regards and safe riding
Simon Buholzer
escooterlab.ch`,
      it: `Buongiorno

La sua richiesta di riparazione è stata pianificata per domani nel nostro tour di ritiro gratuito con officina mobile.
Il nostro autista la contatterà circa un'ora prima dell'arrivo.

Si prega di notare: se il nostro autista arriva ma non viene eseguita alcuna riparazione né affidato alcun ordine di riparazione, addebiteremo una tariffa forfettaria di CHF 30.–. Se decidesse di procedere con la riparazione in un tour successivo, questo importo le verrà accreditato integralmente.

Saluti ecologici e buona guida
Simon Buholzer
escooterlab.ch`,
      fr: `Bonjour

Votre demande de réparation a été planifiée pour demain dans notre tournée de ramassage gratuite avec atelier mobile.
Notre chauffeur vous contactera environ une heure avant l'arrivée.

Veuillez noter: si notre chauffeur se déplace mais qu'aucune réparation n'est effectuée ou qu'aucun mandat de réparation n'est passé, nous facturerons un forfait de déplacement de CHF 30.–. Si vous décidez de procéder à la réparation lors d'une tournée ultérieure, ce montant vous sera intégralement crédité.

Salutations écologiques et bonne route
Simon Buholzer
escooterlab.ch`,
    },
  },
  {
    key: 'missedcall2607',
    label: 'Missed call (detailed)',
    command: 'missed call detailed',
    aliases: ['missedcall2607', 'anruf verpasst detailliert', 'missed call 2607', 'verpasst detailliert'],
    messages: {
      de: `Grüezi

Vielen Dank für Ihren Anruf bei E-ScooterLab. Leider haben wir Ihren Anruf verpasst.

Damit wir Ihre Anfrage schnell bearbeiten können, teilen Sie uns bitte kurz mit, wobei wir Ihnen helfen dürfen:

• E-Scooter reparieren
• E-Scooter kaufen
• E-Scooter verkaufen
• E-Scooter mieten
• Ersatzteile oder Werkzeuge

Bitte senden Sie uns bitte zusätzlich:

• Marke
• Modell
• Eine kurze Beschreibung des Anliegens oder Defekts

Gerne organisieren wir anschliessend einen Rückruf oder helfen Ihnen direkt per Chat weiter.

Vielen Dank – wir freuen uns auf Ihre Nachricht.

Umweltfreundliche Grüsse und sichere Fahrt.

Simon Buholzer
E-ScooterLab`,
      en: `Hello

Thank you for calling E-ScooterLab. Unfortunately, we missed your call.

To help us process your request quickly, please let us know how we can assist you:

• E-scooter repair
• Buy an e-scooter
• Sell an e-scooter
• Rent an e-scooter
• Spare parts or tools

Please also send us:

• Brand
• Model
• A brief description of your concern or defect

We will then arrange a callback or help you directly via chat.

Thank you – we look forward to hearing from you.

Eco-friendly regards and safe riding.

Simon Buholzer
E-ScooterLab`,
      it: `Buongiorno

Grazie per aver chiamato E-ScooterLab. Purtroppo abbiamo perso la sua chiamata.

Per poter elaborare rapidamente la sua richiesta, ci comunichi gentilmente in cosa possiamo aiutarla:

• Riparazione e-scooter
• Acquisto e-scooter
• Vendita e-scooter
• Noleggio e-scooter
• Ricambi o attrezzi

La preghiamo inoltre di inviarci:

• Marca
• Modello
• Una breve descrizione del problema o del difetto

Organizzeremo poi una richiamata o la aiuteremo direttamente via chat.

Grazie – aspettiamo il suo messaggio con piacere.

Saluti ecologici e buona guida.

Simon Buholzer
E-ScooterLab`,
      fr: `Bonjour

Merci d'avoir appelé E-ScooterLab. Malheureusement, nous avons manqué votre appel.

Pour traiter votre demande rapidement, merci de nous indiquer comment nous pouvons vous aider:

• Réparation de trottinette électrique
• Achat d'une trottinette électrique
• Vente d'une trottinette électrique
• Location d'une trottinette électrique
• Pièces de rechange ou outils

Merci de nous envoyer également:

• Marque
• Modèle
• Une brève description de votre demande ou du défaut

Nous organiserons ensuite un rappel ou vous aiderons directement par chat.

Merci – nous attendons votre message avec impatience.

Salutations écologiques et bonne route.

Simon Buholzer
E-ScooterLab`,
    },
  },
  {
    key: 'readytodrive',
    label: 'Ready to drive (eco)',
    command: 'readytodrive',
    aliases: ['ready to drive eco', 'abholbereit eco', 'sichere fahrt'],
    messages: {
      de: `Grüezi

Ihr E-Scooter steht zur Abholung bereit. Bitte lassen Sie uns wissen, wann es Ihnen am besten passt, ihn abzuholen.

Wir wünschen Ihnen eine angenehme Fahrt und stehen Ihnen bei Fragen gerne zur Verfügung.

Umweltfreundliche Grüsse und sichere Fahrt
Ihr eScooterLab Team`,
      en: `Hello

Your e-scooter is ready for collection. Please let us know when it suits you best to pick it up.

We wish you a pleasant ride and remain available if you have any questions.

Eco-friendly regards and safe riding
Your eScooterLab Team`,
      it: `Buongiorno

Il suo e-scooter è pronto per il ritiro. La preghiamo di farci sapere quando le è più comodo ritirarlo.

Le auguriamo una piacevole guida e restiamo a disposizione per qualsiasi domanda.

Saluti ecologici e buona guida
Il team eScooterLab`,
      fr: `Bonjour

Votre e-scooter est prêt à être récupéré. Merci de nous indiquer le moment qui vous convient le mieux pour venir le chercher.

Nous vous souhaitons une bonne route et restons à votre disposition pour toute question.

Salutations écologiques et bonne route
Votre équipe eScooterLab`,
    },
  },
];

const stripAccents = (value) => (
  (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
);

export const normalizeTemplateCommand = (value) => (
  stripAccents(value)
    .toLowerCase()
    .replace(/^\/+/, '')
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
);

const templateCommandValues = (template) => [
  template.key,
  template.label,
  template.command,
  ...(template.aliases || []),
];

export const resolveTemplateCommand = (value) => {
  const command = normalizeTemplateCommand(value);
  if (!command) return null;

  return MESSAGE_TEMPLATES.find((template) => (
    templateCommandValues(template).some((candidate) => normalizeTemplateCommand(candidate) === command)
  )) || null;
};

export const findTemplateCommandMatches = (value) => {
  const command = normalizeTemplateCommand(value);
  if (!command) return MESSAGE_TEMPLATES;

  return MESSAGE_TEMPLATES.filter((template) => (
    templateCommandValues(template).some((candidate) => normalizeTemplateCommand(candidate).includes(command))
  ));
};
